import { TLang, TParams } from '@/types'

export const reservePath = '/reserve'
export const commitPath = `${reservePath}/commit`
export const extrasPath = `${reservePath}/extras`
export const confirmedPath = `${reservePath}/confirmed`
export const canceledPath = `${reservePath}/canceled`
export const selectVehiclePath = `${reservePath}/select-vehicle`
export const pickupAndReturn = `${reservePath}/pickup-and-return`

// static paths
export const homePath = '/'
export const aboutUsPath = '/about-us'
export const carHirePath = '/car-hire'
export const carRentalLocationsPath = '/car-rental-locations'
export const contactUsPath = '/contact-us'
export const cookiePolicyPath = '/cookie-policy'
export const oneWayRentalsPath = '/one-way-rentals'
export const privacyPolicyPath = '/privacy-policy'
export const termsOfUsePath = '/terms-of-use'
export const vehiclesPath = '/vehicles'
export const viewModifyCancelPath = '/view-modify-cancel'
export const faqPath = '/faq'
export const travelBlogPath = '/travel-blog'
export const termsAndConditionsPath = '/terms-and-conditions'

export const internationalLocationsPath =
  process.env.NEXT_PUBLIC_INTERNATIONAL_LOCATIONS_PATH ?? ''

export const yerevanSlug = 'rent-a-car-in-yerevan'
export const yerevanAirportSlug = 'car-rental-yerevan-airport'

export const generatePath = (
  path: string,
  params: TParams = {},
  queryData?: Record<string, string | number | boolean>[],
): string => {
  let newPath: string = path
  Object.keys(params).forEach(param => {
    newPath = newPath.replace(`:${param}`, `${params[param] || ''}`)
  })

  if (queryData && queryData.length > 0) {
    const query = queryData
      .map(item => Object.keys(item)[0] + '=' + Object.values(item)[0])
      .join('&')
    newPath = newPath + '?' + query
  }

  return newPath
}

export const restrictedPaths = [
  pickupAndReturn,
  selectVehiclePath,
  extrasPath,
  commitPath,
  confirmedPath,
]

const paths: string[] = [
  homePath,
  aboutUsPath,
  carHirePath,
  contactUsPath,
  cookiePolicyPath,
  oneWayRentalsPath,
  privacyPolicyPath,
  termsOfUsePath,
  vehiclesPath,
  viewModifyCancelPath,
  faqPath,
  // travelBlogPath,
  termsAndConditionsPath,
  generatePath(carRentalLocationsPath, undefined, [
    { location: yerevanSlug },
  ]),
  generatePath(carRentalLocationsPath, undefined, [
    { location: yerevanAirportSlug },
  ]),
]

export const appPaths: Record<TLang, string[]> = {
  en: paths,
  ru: paths,
}
